import { ChatList } from 'model/modules/chat/chatList';

export const uniqueChatItems = <T extends { id: number }>(items: T[]): T[] => {
  const unique = new Map<number, T>();
  items.forEach((item) => unique.set(item.id, item));

  return Array.from(unique.values());
};

export default function mergeChatList(
  current: ChatList,
  incoming: ChatList
): void {
  // First-page refreshes restore server ordering without dropping loaded pages.
  if (incoming.chats.currentPage === 1) {
    const refreshedIds = new Set(incoming.chats.items.map((item) => item.id));
    current.chats.items = uniqueChatItems([
      ...incoming.chats.items,
      ...current.chats.items.filter((item) => !refreshedIds.has(item.id)),
    ]);
  } else {
    current.chats.items = uniqueChatItems([
      ...current.chats.items,
      ...incoming.chats.items,
    ]);
  }
  current.chats.pageCount = incoming.chats.pageCount;
  current.chats.currentPage = Math.min(
    incoming.chats.pageCount,
    Math.max(current.chats.currentPage, incoming.chats.currentPage)
  );
  current.chats.itemsCount = incoming.chats.itemsCount;
  current.totalUnreadMessages = incoming.totalUnreadMessages;
}
